import { getArtistsAction } from './actions';
import { defaultListParams, listReducer } from '../../utils/crudUtils';

export const key = 'Artists';

export const initialState = {
  artistsList: defaultListParams,
};

const artistsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getArtistsAction.TRIGGER:
    case getArtistsAction.SUCCESS:
    case getArtistsAction.FAILURE:
      return listReducer(state, type, payload, 'artistsList');

    default:
      return state;
  }
};

export default artistsReducer;
